import _ from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HttpResponse } from '../../../../../../../common/ajax';
import CheckInFrame from '../../../../../../../common/assets/images/time-and-attendance-check-in.svg';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../../common/global/helpers';
import useMount from '../../../../../../../common/hooks/useMount';
import Loader from '../../../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../../../common/widgets/LoadingSpinner';
import { resources } from '../../../../../resources/resources';
import { timeAndAttendanceService } from '../../../../../services/time-and-attendance';
import { AttendancecurrentAction } from './common';

export const AttendanceCheckIn = () => {
  const [attendanceStatus, setAttendanceStatus] = useState<
    AttendancecurrentAction | undefined
  >(undefined);

  const loadAttendanceStatus = async (abortController?: AbortController) => {
    const result = await timeAndAttendanceService.getCheckinStatus({
      signal: abortController?.signal,
    });

    if (abortController?.signal.aborted) {
      return;
    }

    if (!result.hasErrors) {
      setAttendanceStatus(result.data);
    } else {
      showErrorToast(translate(resources.errors.generic));
    }
  };

  useMount(async abortController => {
    await loadAttendanceStatus(abortController);
  });

  const handleAttendaceStatusChange = async () => {
    const abortController = new AbortController();

    let result: HttpResponse<boolean> | undefined = undefined;
    const prevAttendance = attendanceStatus;
    setAttendanceStatus(undefined);

    if (prevAttendance === AttendancecurrentAction.CheckIn) {
      result = await timeAndAttendanceService.attendanceCheckIn({
        signal: abortController?.signal,
      });
    } else if (prevAttendance === AttendancecurrentAction.CheckOut) {
      result = await timeAndAttendanceService.attendanceCheckOut({
        signal: abortController?.signal,
      });
    }

    if (abortController?.signal.aborted) {
      return;
    }

    if (!result || result.hasErrors || !!result.data) {
      showErrorToast(translate(resources.errors.generic));
      return;
    }

    const newAttendanceStatus =
      prevAttendance === AttendancecurrentAction.CheckIn
        ? AttendancecurrentAction.CheckOut
        : AttendancecurrentAction.DisabledCheckOut;
    setAttendanceStatus(newAttendanceStatus);

    showSuccessToast(
      prevAttendance === AttendancecurrentAction.CheckIn
        ? translate(resources.timeAndAttendance.checkIn.saveCheckIn)
        : translate(resources.timeAndAttendance.checkIn.saveCheckOut),
      false,
    );
  };

  const { t: translate } = useTranslation();

  const currentTime = moment();

  return (
    <Loader loading={_.isNil(attendanceStatus)} loader={<LoadingSpinner />}>
      <div className="aci-container">
        <img
          src={CheckInFrame}
          alt={translate(resources.timeAndAttendance.checkInButton)}
        />
        <div className="aci-hour-text">{`${currentTime.hour()}:${
          currentTime.minute() < 10
            ? `0${currentTime.minute()}`
            : currentTime.minute()
        }`}</div>
        <div className="aci-description-text small-text">
          {attendanceStatus === AttendancecurrentAction.CheckIn
            ? translate(resources.timeAndAttendance.checkIn.begin)
            : translate(resources.timeAndAttendance.checkIn.finish)}
        </div>
        <button
          disabled={
            attendanceStatus === AttendancecurrentAction.DisabledCheckOut
          }
          onClick={() => {
            handleAttendaceStatusChange();
          }}
          className={`btn ${
            attendanceStatus !== AttendancecurrentAction.DisabledCheckOut
              ? 'btn-solid'
              : 'btn-outline'
          } btn-lg`}
        >
          <span className="btn-text">
            {attendanceStatus === AttendancecurrentAction.CheckIn
              ? translate(resources.timeAndAttendance.checkInButton)
              : translate(resources.timeAndAttendance.checkOutButton)}
          </span>
        </button>
      </div>
    </Loader>
  );
};
